import { AiActionTypes } from '../actions/aiActions';
import { RootActions } from '../redux';
import { aiState, AiState } from '../states/aiState';

const aiReducer = (state = aiState, action: RootActions): AiState => {
  switch (action.type) {
    case AiActionTypes.TOGGLE_AI:
      return {
        ...state,
        aiVisible: action.payload,
      };
    case AiActionTypes.UPDATE_FEEBACK_ITEM: {
      const payloadItems = Array.isArray(action.payload) ? action.payload : [action.payload];

      const updatedConversationList = state.conversationList.map((existingItem) => {
        const payloadItem = payloadItems.find((item) => item.log_id && item.log_id === existingItem.log_id);

        if (payloadItem) {
          return {
            ...existingItem,
            feedback: payloadItem.feedback, // Only update feedback
          };
        }

        return existingItem; // Return unchanged item
      });

      return {
        ...state,
        conversationList: updatedConversationList,
      };
    }

    case AiActionTypes.GET_CONVERSATION_LIST: {
      // Add opening curly brace here
      const newConversationsToAdd = Array.isArray(action.payload) ? action.payload : [action.payload];
      return {
        ...state,
        conversationList: [...state.conversationList, ...newConversationsToAdd],
      };
    }

    case AiActionTypes.CLEAR_CONVERSATION_LIST:
      return {
        ...state,
        conversationList: [], // ✅ Clear the conversation list
      };

    default:
      return state;
  }
};

export default aiReducer;
